<template>
  <div class="layout">
    <!-- 選單 -->
    <div class="box" v-for="(box, index) in menu" :key="index"></div>
    <div :class="{ fixMenu: fixed, unFixMenu: !fixed }"></div>
    <!-- 空白 -->
    <br><br><br><br><br><br><br><br><br><br>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      menu: 10,
      fixed: true
    };
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted() {
  },
  methods: {
    handleScroll() {
      const height = 860 - document.documentElement.clientHeight
      var scrollH = document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollH >= height) {
        this.fixed = false;
      }
      else {
        this.fixed = true;
      }
    }
  }
}

</script>

<style scoped>
  .layout {
    overflow: scroll;
  }
  .box {
    border: 1px solid #999;
    height: 80px;
  }
  .fixMenu {
    border: 1px solid #999;
    height: 60px;
    background-color: #f24;
    position: fixed;
    bottom: 0;
    width: 100%;
  }
  .unFixMenu {
    border: 1px solid #999;
    width: 100%;
    height: 60px;
    background-color: #f24;
  }
</style>